import { render } from "./HSK.vue?vue&type=template&id=3efc6aa2&scoped=true"
import script from "./HSK.vue?vue&type=script&lang=js"
export * from "./HSK.vue?vue&type=script&lang=js"

import "./HSK.vue?vue&type=style&index=0&id=3efc6aa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efc6aa2"]])

export default __exports__